import React from 'react';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import InstructionRepeatOverlay from '../FormativeMultipleChoice/InstructionRepeatOverlay';

export default function SequencingMediaSection({
  hasVideo,
  hasImage,
  hideMedia,
  videoURL,
  imageURL,
  speech,
  videoPlaying,
  maxVideoReplays,
  onVideoReplay,
  unmountVideoWhenDone,
  suppressVideoReplayOverlay,
  showRepeatOverlay,
  showRepeatOverlayReplay,
  pointerTarget,
  onRepeatOverlayReplay,
  onRepeatOverlayNext,
  onVideoStart,
  onVideoDone,
}) {
  const showsVideo = hasVideo && !hideMedia;
  const showsImage = hasImage && !hasVideo && !hideMedia;

  if (!showsVideo && !showsImage) {
    if (!showRepeatOverlay) return null;
    return (
      <div className="sequencing__media">
        <div className="sequencing__mediaSlot sequencing__audioOnlySlot">
          <InstructionRepeatOverlay
            pointerTarget={pointerTarget}
            showReplay={showRepeatOverlayReplay}
            onReplay={onRepeatOverlayReplay}
            onNext={onRepeatOverlayNext}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="sequencing__media">
      {showsVideo && (
        <div className="sequencing__mediaSlot">
          <VideoPlayer
            videoURL={videoURL}
            text="Sequencing Video"
            unmountWhenDone={unmountVideoWhenDone}
            key="sequencingVideo"
            speech={speech}
            videoPlaying={videoPlaying}
            maxReplays={maxVideoReplays}
            onReplayClick={onVideoReplay}
            suppressReplayOverlay={suppressVideoReplayOverlay}
            onStart={onVideoStart}
            onDone={onVideoDone}
            useButtonLabels={false}
            useClearButtons
          />
          {showRepeatOverlay && (
            <InstructionRepeatOverlay
              pointerTarget={pointerTarget}
              showReplay={showRepeatOverlayReplay}
              onReplay={onRepeatOverlayReplay}
              onNext={onRepeatOverlayNext}
            />
          )}
        </div>
      )}
      {showsImage && (
        <div className="sequencing__staticImage">
          <div className="sequencing__staticImageCell">
            <img src={imageURL} alt="Sequencing prompt" />
            {showRepeatOverlay && (
              <InstructionRepeatOverlay
                pointerTarget={pointerTarget}
                showReplay={showRepeatOverlayReplay}
                onReplay={onRepeatOverlayReplay}
                onNext={onRepeatOverlayNext}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
